/**
 * Web Push subscription helpers (VAPID) — for browsers/PWA
 */
import api from './api';

export const isPushSupported = () =>
  typeof window !== 'undefined' &&
  'serviceWorker' in navigator &&
  'PushManager' in window &&
  'Notification' in window;

const urlBase64ToUint8Array = (base64String) => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i++) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};

const getOrCreateSubscription = async () => {
  const registration = await navigator.serviceWorker.ready;
  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    const { data } = await api.get('/v2/push/vapid-public-key');
    if (!data?.publicKey) throw new Error('no-key');
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.publicKey),
    });
  }
  return subscription;
};

// Full flow: ask permission (if needed), subscribe, register with backend
export const subscribeToPush = async () => {
  if (!isPushSupported()) return { ok: false, reason: 'unsupported' };
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') return { ok: false, reason: 'denied' };
  try {
    const subscription = await getOrCreateSubscription();
    await api.post('/v2/push/subscribe', subscription.toJSON());
    return { ok: true };
  } catch (e) {
    return { ok: false, reason: 'error' };
  }
};

// Silent re-sync on app load when permission was already granted
export const syncPushSubscription = async () => {
  try {
    if (!isPushSupported() || Notification.permission !== 'granted') return;
    const subscription = await getOrCreateSubscription();
    await api.post('/v2/push/subscribe', subscription.toJSON());
  } catch (e) {
    // silent
  }
};
